import React, { Component } from 'react'
import SearcheableUserSelect from 'components/Users/SearcheableUserSelect'
import { providesCreateUserGroup } from 'components/Organizations/dataSync/userGroups'
import { ThinChevronIcon } from 'components/Utils/Icons'
import { Button, Text } from 'components/base'
import { Input } from 'components/Utils/Form'

function FormLabel({ children, htmlFor }) {
  return (
    <div className="margin-vertical-normal">
      <label htmlFor={htmlFor} className="shade-05 font-weight-bold pointer">
        {children}
      </label>
    </div>
  )
}

class CreateGroup extends Component {
  state = {
    selectedUserIds: [],
    groupName: '',
  }
  render() {
    return (
      <form style={{ width: 526 }} onSubmit={this.onCreateUserGroup}>
        <div
          onClick={() => this.props.goToList()}
          className="pointer flexbox flexbox-align-center"
        >
          <ThinChevronIcon
            size={12}
            className="margin-right-small shade-30"
            style={{ transform: 'rotate(180deg)' }}
          />
          <span className="shade-20">Back to your groups</span>
        </div>
        <Text.Subtitle className="margin-top-medium margin-bottom-large">
          Create a group
        </Text.Subtitle>
        <FormLabel htmlFor="user-group-name">Pick a name</FormLabel>
        <Input
          id="user-group-name"
          className="margin-bottom-normal"
          value={this.state.groupName}
          onChange={event => this.setState({ groupName: event.target.value })}
          style={{ width: 270 }}
          placeholder="E.g, leadership, sales, developers"
          required
          autoFocus
        />
        <FormLabel htmlFor="user-group-members">Choose group members</FormLabel>
        <SearcheableUserSelect
          selectedValues={this.state.selectedUserIds}
          onChange={selectedUserIds => this.setState({ selectedUserIds })}
          inputProps={{
            id: 'user-group-members',
            placeholder: 'Search for a member',
          }}
        />
        <Button.Primary
          className="margin-top-large"
          type="button"
          onClick={this.onCreateUserGroup}
          disabled={!this.state.groupName}
        >
          Create Group
        </Button.Primary>
      </form>
    )
  }

  onCreateUserGroup = event => {
    event.preventDefault()
    event.stopPropagation()
    if (!this.state.groupName) {
      return
    }
    this.props
      .createUserGroup({
        input: {
          userIds: this.state.selectedUserIds,
          name: this.state.groupName,
        },
      })
      .then(() => this.props.goToList())
  }
}

export default providesCreateUserGroup()(CreateGroup)
